import React from 'react';
import {
  TypeImplementation,
  Plugins,
  Component,
  ExpressionPath,
} from '@packages/systems/wfdl';
import {
  ExpressionEditor,
  extendExpressionEditorActionAtPath,
} from '@packages/systems/ExpressionEditor-utils';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {reportBug} from '@packages/utilities/reporter';
import {findComponentPath} from '../utils';
import {qualify} from '@packages/systems/wfdl-Qualified';

import {
  ContextualExpressions,
  stripAll,
} from '@packages/utilities/contextual-expression';

const {getIn} = ContextualExpressions;

const RadioChildrenType = TypeImplementation.Alias({
  type: TListOfElement,
  render: function RenderRadioChildren({expr, dispatch}) {
    const strippedExpr = stripAll(expr);

    const radioInputPath = findComponentPath(
      strippedExpr,
      qualify(Plugins.name('Form'), Component.name('FormRadioInput'))
    );

    if (!radioInputPath) {
      reportBug(
        'FormRadioInputNotFoundInFormRadioWrapper',
        'Form Radio Input has not been found in Form Radio Wrapper',
        {
          expr: strippedExpr,
          team: 'platform',
          ticket: 'https://webflow.atlassian.net/browse/PLAT-1060',
        }
      );
      return null;
    }
    const path = [...radioInputPath, {in: 'Element'}] satisfies ExpressionPath;
    const radioInputData = getIn(expr, path);
    if (!radioInputData) return null;
    const onRadioInputDataChange =
      extendExpressionEditorActionAtPath(dispatch)(path);
    return (
      <ExpressionEditor
        expression={radioInputData}
        dispatch={onRadioInputDataChange}
      />
    );
  },
});

export default RadioChildrenType;
